<div class="countries-regions-buttons" [class.destination-button-t2]="theme() === GbTheme.ThemeTwo">
  <a
    [href]="leftHref()"
    class="default-button primary-font-medium"
    (click)="$event.preventDefault(); setModelValue(leftValue())"
    [class.active-button]="value() === leftValue()"
    [class.rounded-pill]="theme() === GbTheme.ThemeOne"
    [class.button-t2]="theme() === GbTheme.ThemeTwo"
  >
    <span>
      <ng-content select="[left]"></ng-content>
    </span>
  </a>
  <a
    [href]="rightHref()"
    class="default-button primary-font-medium"
    (click)="$event.preventDefault(); setModelValue(rightValue())"
    [class.active-button]="value() === rightValue()"
    [class.rounded-pill]="theme() === GbTheme.ThemeOne"
    [class.button-t2]="theme() === GbTheme.ThemeTwo"
  >
    <span>
      <ng-content select="[right]"></ng-content>
    </span>
  </a>
</div>
